







































import Vue from 'vue';
import axios from 'axios';

const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';

interface Prediction {
  'From Network': number;
  'General': number;
  'Into Network': number;
}

export default Vue.extend({
  name: 'TransportPlanning',
  data() {
    return {
      depots: [] as string[],
      selectedDepot: '',
      predictions: {} as {[date: string]: Prediction},
      loading: true,
    };
  },
  computed: {
    types(): string[] {
      return ['From Network', 'General', 'Into Network'];
    },
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.depots = (await axios.get<{depots: string[]}>(`${BASE_URL}/reports/depots/`)).data.depots;
      this.selectedDepot = this.depots[0];
      const response = await axios.get(`${BASE_URL}/reports/transport-planning/${this.selectedDepot}/`);
      this.predictions = response.data.result;
      this.loading = false;
    },
    formatDate(date: string) {
      const day = date.slice(8);
      const month = date.slice(5, 7);
      return `${day}-${month}`;
    },
    getStyle(dayName: string) {
      if (dayName.startsWith('Sat') || dayName.startsWith('Sun')) {
        return 'weekend';
      }
      return 'weekday';
    },
  },
});
